module.exports = "/static/assets/b46e0ae877de42554ae321fb4e9ce420.png";